<template>
  <div class="remove_class">
    <el-dialog
      title="替换"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :width="module == 1 ? '500px' : '1100px'"
      class="dialog_title"
      @close="onClose"
      @closed="onClosed"
    >
      <Reason ref="reason" @change="reasonChange" v-if="module == 1"></Reason>
      <div v-if="module == 2">
        <el-tabs v-model="tabsActiveName" @tab-click="tabsHandleClick">
          <el-tab-pane label="选择已有用户" name="old"></el-tab-pane>
          <el-tab-pane label="添加新用户" name="new"></el-tab-pane>
        </el-tabs>
        <UserList ref="userList" v-if="tabsActiveName == 'old'"></UserList>
        <AddUser
          ref="addUser"
          @requestCommonFn="addUserRequestCommonFn"
          v-if="tabsActiveName == 'new'"
        ></AddUser>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()" size="small">确 定</el-button>
        <el-button @click="close()" size="small">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { putApiStudentReplace, postApiStudentReplace } from "@/api/tearcher";
import Reason from "./reason.vue";
import UserList from "./userList.vue";
import AddUser from "./addUser.vue";
export default {
  components: {
    Reason,
    UserList,
    AddUser,
  },
  data() {
    return {
      dialogVisible: false, //弹窗是否显示
      module: 1, //模块1.原因2.选择已有用户、添加新用户
      tabsActiveName: "old", //tabs当前选中值
      //表单数据
      formData: {
        user_id: "",
        deleted_remark: "",
      },
      //外部数据
      externalData: {
        user_id: 0, //用户id
        areaTreesArr: [], //省市区
        titleOptions: [], //职称列表
        unitOptions: [], //单位列表
        levelOptions: [], //学段列表
        educationOptions: [], //学历列表
        class_id: "", //班级id
        type: "", //用户角色类型
      },
    };
  },
  methods: {
    //学员替换
    putStudentReplace(type, e) {
      let promise = "";

      if (type == "old") {
        promise = putApiStudentReplace(this.externalData.user_id, e);
      } else {
        promise = postApiStudentReplace(this.externalData.user_id, e);
      }

      promise.then((res) => {
        if (res.error_code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: messageDuration,
          });
          this.$emit("requestCommonFn");
          this.close();
        }
      });
    },
    //tabs点击选择回调
    tabsHandleClick(tab) {
      if (tab.name == "old") {
        this.userListOperationDialog();
      }
      if (tab.name == "new") {
        this.addUserOperationDialog();
      }
    },
    //原因选择回调
    reasonChange(e) {
      console.log(e);
      //判断是否选其他和已填原因
      if (e.id == 2 && e.deleted_remark) {
        this.formData.deleted_remark = e.deleted_remark;
      }
      this.module = 2;
      this.userListOperationDialog();
    },
    //添加新用户回调
    addUserRequestCommonFn(e) {
      //this.formData.user_id = e.user_id;
      this.putStudentReplace("new", e);
    },
    //确定按钮
    submit() {
      if (this.module == 1) {
        this.$refs["reason"].submitForm();
        return;
      }
      if (this.module == 2) {
        if (this.tabsActiveName == "old") {
          this.$refs["userList"].submitForm().then((id) => {
            if (id) {
              this.formData.user_id = id;
              this.putStudentReplace("old", this.formData);
            }
          });
        }
        if (this.tabsActiveName == "new") {
          this.$refs["addUser"].submitForm();
        }
      }
    },
    //关闭按钮
    close() {
      this.dialogVisible = false;
    },
    //关闭回调
    onClose() {},
    //关闭结束回调
    onClosed() {
      this.module = 1;
      this.tabsActiveName = "old";
    },
    //操作dialog
    operationDialog(e) {
      this.externalData.user_id = e.user_id; //省市区
      this.externalData.areaTreesArr = e.areaTreesArr; //省市区
      this.externalData.titleOptions = e.titleOptions; //职称列表
      this.externalData.unitOptions = e.unitOptions; //单位列表
      this.externalData.levelOptions = e.levelOptions; //学段列表
      this.externalData.educationOptions = e.educationOptions; //学历列表
      this.externalData.class_id = e.class_id; //班级id
      this.externalData.type = e.type; //班级id

      this.dialogVisible = true;
    },
    //选择已有用户
    userListOperationDialog() {
      this.$nextTick(() => {
        this.$refs["userList"].operationDialog(
          this.externalData.areaTreesArr,
          this.externalData.titleOptions,
          this.externalData.unitOptions,
          this.externalData.levelOptions,
          this.externalData.type,
          this.externalData.class_id
        );
      });
    },
    //添加新用户
    addUserOperationDialog() {
      const title = "添加新学员";
      this.$nextTick(() => {
        this.$refs["addUser"].operationDialog(
          this.externalData.educationOptions,
          this.externalData.unitOptions,
          this.externalData.titleOptions,
          this.externalData.levelOptions,
          this.externalData.class_id,
          "",
          "",
          title
        );
      });
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped></style>
